import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Container } from 'unstated';
import { CONTENT_NAV_WIDTH } from '../common/constants';
var defaultState = {
  isResizing: false,
  isResizeDisabled: false,
  isCollapsed: false,
  productNavWidth: CONTENT_NAV_WIDTH
};

var UIController = /*#__PURE__*/function (_Container) {
  _inherits(UIController, _Container);

  var _super = _createSuper(UIController);

  function UIController(initialState, cache) {
    var _this;

    _classCallCheck(this, UIController);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "getCache", void 0);

    _defineProperty(_assertThisInitialized(_this), "setCache", void 0);

    _defineProperty(_assertThisInitialized(_this), "isCollapsedStore", void 0);

    _defineProperty(_assertThisInitialized(_this), "storeState", function (state) {
      _this.setState(state);

      var _this$state = _this.state,
          isCollapsed = _this$state.isCollapsed,
          productNavWidth = _this$state.productNavWidth;

      if (_this.setCache) {
        _this.setCache({
          isCollapsed: isCollapsed,
          productNavWidth: productNavWidth
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "collapse", function () {
      if (_this.state.isResizeDisabled) {
        return;
      }

      _this.storeState({
        isCollapsed: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "expand", function () {
      if (_this.state.isResizeDisabled) {
        return;
      }

      _this.storeState({
        isCollapsed: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleCollapse", function () {
      var toggle = _this.state.isCollapsed ? _this.expand : _this.collapse;
      toggle();
    });

    _defineProperty(_assertThisInitialized(_this), "manualResizeStart", function (_ref) {
      var productNavWidth = _ref.productNavWidth,
          isCollapsed = _ref.isCollapsed;

      if (_this.state.isResizeDisabled) {
        return;
      }

      _this.storeState({
        isResizing: true,
        productNavWidth: productNavWidth,
        isCollapsed: isCollapsed
      });
    });

    _defineProperty(_assertThisInitialized(_this), "manualResizeEnd", function (_ref2) {
      var productNavWidth = _ref2.productNavWidth,
          isCollapsed = _ref2.isCollapsed;

      if (_this.state.isResizeDisabled) {
        return;
      }

      _this.storeState({
        isResizing: false,
        productNavWidth: productNavWidth,
        isCollapsed: isCollapsed
      });
    });

    _defineProperty(_assertThisInitialized(_this), "enableResize", function () {
      var isCollapsed = typeof _this.isCollapsedStore === 'boolean' ? _this.isCollapsedStore : _this.state.isCollapsed; // This is a page-level setting not a user preference so we don't cache
      // this.

      _this.setState({
        isCollapsed: isCollapsed,
        isResizeDisabled: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "disableResize", function () {
      // Remember this so that we can reset it if resizing is enabled again.
      _this.isCollapsedStore = _this.state.isCollapsed; // This is a page-level setting not a user preference so we don't cache
      // this.

      _this.setState({
        isCollapsed: false,
        isResizeDisabled: true
      });
    });

    var cachedState = {};

    if (cache) {
      var get = cache.get,
          set = cache.set;
      var retrievedCache = get();

      if (retrievedCache) {
        var isCollapsed = retrievedCache.isCollapsed,
            productNavWidth = retrievedCache.productNavWidth;
        cachedState = {
          isCollapsed: isCollapsed,
          productNavWidth: productNavWidth
        };
      }

      _this.getCache = get;
      _this.setCache = set;
    }

    var _state = _objectSpread(_objectSpread(_objectSpread({}, defaultState), cachedState), initialState);

    var _isCollapsed = _state.isCollapsed; // isResizeDisabled takes precedence over isCollapsed

    if (initialState && initialState.isResizeDisabled) {
      // Remember this so that we can reset it if resizing is enabled again.
      _this.isCollapsedStore = _isCollapsed;
      _isCollapsed = false;
    }

    _this.state = _objectSpread(_objectSpread({}, _state), {}, {
      isCollapsed: _isCollapsed
    });
    return _this;
  }

  return _createClass(UIController);
}(Container);

export { UIController as default };